
/**
 * Copyright 2021 Olympe S.A.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Brick, registerBrick } from 'olympe';

/**
## Description
Attempts to parse the provided string to convert it into a boolean value.
I.E. If the string is 'true' (case-insensitive match), then it returns `true`, otherwise `false`.

## Inputs
| Name | Type | Description |
| --- | :---: | --- |
| s | String | The string to convert. |
## Outputs
| Name | Type | Description |
| --- | :---: | --- |
| boolean | Boolean | The result of the conversion. |

**/
export default class ParseBoolean extends Brick {

    /**
     * @protected
     * @param {!BrickContext} context
     * @param {string} s
     * @param {function(boolean)} setBoolean
     */
    update(context, [s], [setBoolean]) {
        setBoolean(String(s).toLowerCase() === "true");
    }
}

registerBrick('01633f1440e8af58e199', ParseBoolean);
